"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const DragDropHelp_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/modals/DragDropHelp.vue"));
const SelectorPrj_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/modals/SelectorPrj.vue"));
const DropIncorrectFiles_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/modals/DropIncorrectFiles.vue"));
const DropFilesDiscarted_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/modals/DropFilesDiscarted.vue"));
const DragDropSameFiles_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/modals/DragDropSameFiles.vue"));
const DragDropLoader_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/DragDropLoader.vue"));
const ModalErrorBase_vue_1 = __importDefault(require("./modals/ModalErrorBase.vue"));
const DragDropInstructions_vue_1 = __importDefault(require("./DragDropInstructions.vue"));
const FieldsSetupFlowController_1 = __importDefault(require("../modules/controllers/FieldsSetupFlowController"));
const FileDrop_1 = __importDefault(require("../modules/models/FileDrop"));
const jszip_1 = __importDefault(require("jszip"));
let DragAndDrop = class DragAndDrop extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.MAIN_CONTROLLER.filesSummaryStep;
        this.NEXT_STEP_CONTROLLER = this.MAIN_CONTROLLER.fieldsPreviewTableStep;
        this.uploadedFiles = [];
        this.selectedFileType = '';
        this.dragOver = false;
        this.uploadedSHPFiles = [];
        this.incorrectFiles = [];
        this.discardedFiles = [];
        this.isSelectorPrjModal = false;
        this.isDragDropHelpModal = false;
        this.isDropIncorrectFilesModal = false;
        this.isDropFilesDiscartedModal = false;
        this.isDropSameFilesModal = false;
        this.isLoading = false;
        this.isErrorBaseModal = false;
    }
    closeModalBaseError() {
        this.isErrorBaseModal = false;
    }
    closeDropSameFilesModal() {
        this.isDropSameFilesModal = false;
    }
    deployDropFilesDiscartedModal() {
        this.isDropFilesDiscartedModal = true;
    }
    closeDropFilesDiscartedModal() {
        this.isDropFilesDiscartedModal = false;
        if (this.uploadedFiles.length > 0) {
            this.validateFiles();
        }
    }
    deployDropIncorrectFilesModal() {
        this.isDropIncorrectFilesModal = true;
    }
    closeDropIncorrectFilesModal() {
        this.isDropIncorrectFilesModal = false;
    }
    deployDragDropHelpModal() {
        this.isDragDropHelpModal = true;
    }
    closeDragDropHelpModal() {
        this.isDragDropHelpModal = false;
    }
    deploySelectorPrjModal() {
        this.isSelectorPrjModal = true;
    }
    closeSelectorPrjModal() {
        this.isSelectorPrjModal = false;
    }
    async processFiles() {
        this.isLoading = true;
        this.STEP_CONTROLLER.uploadFiles(this.uploadedFiles);
        await this.STEP_CONTROLLER.sendFiles(this.MAIN_CONTROLLER.selectedPrjCode);
        let mode = (this.MAIN_CONTROLLER.isAddingFields) ? 'Edition' : 'Setup';
        let logEv = {
            name: `Farm ${mode} Step 1 Completed: Workflow Selection`,
            status: 'ok',
            props: {
                'workflow': 'files'
            }
        };
        if (this.STEP_CONTROLLER.errorCall()[0]) {
            this.isDropSameFilesModal = true;
            this.STEP_CONTROLLER.resetStep();
            logEv.status = 'error';
        }
        else {
            this.MAIN_CONTROLLER.setCurrentStep(this.STEP_CONTROLLER);
        }
        this.MAIN_CONTROLLER.logActivity(logEv);
        this.isLoading = false;
    }
    hasPrjFile(files) {
        const shpFiles = files.filter(file => file.extension === 'shp');
        return shpFiles.every(shpFile => shpFile.subFiles.some(subFile => subFile.extension === 'prj'));
    }
    validateFiles() {
        if (this.hasPrjFile(this.uploadedFiles) && this.uploadedFiles.length > 0)
            this.processFiles();
        else
            this.isSelectorPrjModal = true;
    }
    get filesTypesShp() {
        return ['.shp', '.shx', '.dbf', '.prj'];
    }
    get acceptedTypes() {
        return '.kml, .kmz, .shp, .shx, .dbf, .prj, .zip';
    }
    toggleDragOver(isOver) {
        this.dragOver = isOver;
        (event === null || event === void 0 ? void 0 : event.target).classList.toggle('drag-over', isOver);
    }
    drop(event) {
        var _a;
        event.preventDefault();
        this.toggleDragOver(false);
        this.handleFiles((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files);
    }
    handleFile(event) {
        this.handleFiles(event.target.files);
        const fileT = this.$refs.fileInput;
        fileT.value = '';
    }
    async handleFiles(files) {
        this.incorrectFiles = [];
        this.discardedFiles = [];
        this.uploadedSHPFiles = [];
        this.uploadedFiles = [];
        this.STEP_CONTROLLER.resetStep();
        if (files) {
            const filesArray = Array.from(files);
            for (const file of filesArray) {
                const size = file.size / 1024;
                const fileExtension = file.name.split('.').pop();
                if (this.acceptedTypes.includes(fileExtension)) {
                    if (fileExtension === 'zip') {
                        const extractedFiles = await this.handleZip(file);
                        if (!extractedFiles) {
                            this.isErrorBaseModal = true;
                        }
                        else {
                            extractedFiles.forEach((fileZip) => {
                                const sizeZip = fileZip.size / 1024;
                                const fileExtensionZip = fileZip.name.split('.').pop();
                                if (this.filesTypesShp.includes(`.${fileExtensionZip}`)) {
                                    const fileDrop = new FileDrop_1.default({ name: fileZip.name, file: fileZip, size: sizeZip, sizeUnit: 'kb', extension: fileExtensionZip || '', subFiles: [], metadata: null });
                                    this.uploadedSHPFiles.push(fileDrop);
                                }
                                else {
                                    if (this.acceptedTypes.includes(`.${fileExtensionZip}`)) {
                                        const fileDrop = new FileDrop_1.default({ name: fileZip.name.split('.').slice(0, -1).join('.'), file: fileZip, size: sizeZip, sizeUnit: 'kb', extension: fileExtensionZip || '', subFiles: [], metadata: null });
                                        this.uploadedFiles.push(fileDrop);
                                    }
                                }
                            });
                        }
                    }
                    else if (this.filesTypesShp.includes(`.${fileExtension}`)) {
                        const fileDrop = new FileDrop_1.default({ name: file.name, file: file, size: size, sizeUnit: 'kb', extension: fileExtension, subFiles: [], metadata: null });
                        this.uploadedSHPFiles.push(fileDrop);
                    }
                    else {
                        const fileDrop = new FileDrop_1.default({ name: file.name.split('.').slice(0, -1).join('.'), file: file, size: size, sizeUnit: 'kb', extension: fileExtension, subFiles: [], metadata: null });
                        this.uploadedFiles.push(fileDrop);
                    }
                }
                else {
                    this.deployDropIncorrectFilesModal();
                    this.incorrectFiles.push(file.name);
                }
            }
            if (this.uploadedSHPFiles.length > 0) {
                const groupedFiles = {};
                this.uploadedSHPFiles.forEach(file => {
                    const baseName = file.name.split('.').slice(0, -1).join('.');
                    if (!groupedFiles[baseName]) {
                        groupedFiles[baseName] = [];
                    }
                    groupedFiles[baseName].push(file);
                });
                const requiredExtensions = ["dbf", "shp", "shx"];
                const validGroups = [];
                const discardedFiles = [];
                for (const baseName in groupedFiles) {
                    const group = groupedFiles[baseName];
                    const extensionsInGroup = group.map((file) => file.extension);
                    const isValidGroup = requiredExtensions.every(ext => extensionsInGroup.includes(ext))
                        || (extensionsInGroup.includes("prj") && requiredExtensions.every(ext => extensionsInGroup.includes(ext) || ext === "prj"));
                    if (isValidGroup) {
                        validGroups.push(group);
                    }
                    else {
                        discardedFiles.push(...group);
                    }
                }
                if (validGroups.length > 0) {
                    validGroups.forEach((fileGroup) => {
                        const size = fileGroup.reduce((total, file) => total + file.size, 0);
                        const fileDrop = new FileDrop_1.default({ name: fileGroup[0].name.split('.').slice(0, -1).join('.'), file: null, size: size, sizeUnit: 'kb', extension: 'shp', subFiles: fileGroup, metadata: null });
                        this.uploadedFiles.push(fileDrop);
                    });
                }
                const fileNames_discarded = discardedFiles.map(file => file.name.split('.').slice(0, -1).join('.'));
                if (discardedFiles.length > 0) {
                    this.discardedFiles = fileNames_discarded;
                    this.deployDropFilesDiscartedModal();
                }
            }
            if (!this.isDropFilesDiscartedModal && this.uploadedFiles.length > 0) {
                this.validateFiles();
            }
        }
    }
    getFileExtension(fileName) {
        var _a;
        return ((_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
    }
    async handleZip(file) {
        const zip = new jszip_1.default();
        const extractedFiles = [];
        try {
            const zipContents = await zip.loadAsync(file);
            for (const zipEntry of Object.values(zipContents.files)) {
                const blob = await zipEntry.async("blob");
                if (zipEntry.dir)
                    return;
                extractedFiles.push(new File([blob], zipEntry.name, { type: blob.type }));
            }
            return extractedFiles;
        }
        catch (error) {
            return [];
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Ref)('fileInput')
], DragAndDrop.prototype, "fileInput", void 0);
DragAndDrop = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { DropIncorrectFilesModal: DropIncorrectFiles_vue_1.default, DragDropInstructions: DragDropInstructions_vue_1.default, SelectorPrjModal: SelectorPrj_vue_1.default, DragDropHelpModal: DragDropHelp_vue_1.default, DropFilesDiscartedModal: DropFilesDiscarted_vue_1.default, DragDropSameFiles: DragDropSameFiles_vue_1.default,
            DragDropLoader: DragDropLoader_vue_1.default, ModalErrorBase: ModalErrorBase_vue_1.default
        } })
], DragAndDrop);
exports.default = DragAndDrop;
